import React from 'react';
import classNames from 'classnames';

export default function TabsListItem({
  divider = true,
  title,
  subtitle,
  text,
  icon = '',
  children,
  className,
  orientation = 'horizontal',
  fullWidth = false,
}) {
  return (
    <div
      className={classNames(
        `${
          divider &&
          'mb-40 pb-10 border-solid border-b-[0.1rem] border-b-secondary/50'
        } ${
          orientation === 'horizontal'
            ? 'flex flex-col xl:flex-row xl:justify-between gap-3'
            : 'flex flex-col gap-3'
        }`,
        className,
      )}
    >
      <div className="flex flex-row">
        {icon && (
          <div className="bmc-page-tabs-content-list-item-icon">
            <div className="bmc-page-tabs-content-list-item-icon-inner">
              {typeof icon === 'string' ? <i className={icon} /> : icon}
            </div>
          </div>
        )}

        {title && (
          <div className="bmc-page-tabs-content-list-item-title mr-10">
            <div className="bmc-page-tabs-content-list-item-title-big">
              {title}
            </div>
            {subtitle && (
              <div className="bmc-page-tabs-content-list-item-title-small">
                {subtitle}
              </div>
            )}
          </div>
        )}
      </div>

      {text && (
        <div className={`${fullWidth ? 'w-full' : 'w-[510px]'}`}>
          {Array.isArray(text) ? (
            <div className="flex flex-col gap-2">
              {text.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </div>
          ) : (
            <div className="w-full">{text}</div>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
